export default __webpack_public_path__ + "static/media/emoticon.aeab4424.svg";